'use client';

import React from 'react';
import './XmlEditor.css';
import { observer } from 'mobx-react';

import sheetEditorEntity from '../entities/SheetEditor/SheetEditor';

import { IconButton } from './ui/button';
import {
  PiCheckSquareThin,
  PiNotePencilThin,
  PiXSquareThin,
} from 'react-icons/pi';

const SheetEditor = observer(() => {
  return (
    <>
      <div className='flex flex-nowrap gap-1 rounded-md ml-1 border'>
        <IconButton
          onClick={() => {
            sheetEditorEntity.enableEditing();
          }}
          iconName='SheetEditor'
          disabled={sheetEditorEntity.editingEnabled}
          className={`transition-colors duration-300 ${
            sheetEditorEntity.editingEnabled
              ? 'hover:bg-transparent fill-accent-foreground'
              : ''
          }`}
          data-testid='enable_sheet_editing'
        >
          <PiNotePencilThin
            size={36}
            className={sheetEditorEntity.editingEnabled ? 'fill-zinc-500' : ''}
          />
        </IconButton>
        {sheetEditorEntity.editingEnabled && (
          <div className=' flex items-center flex-none origin-left animate-in slide-in-from-left duration-600'>
            <IconButton
              noHover
              onClick={() => {
                sheetEditorEntity.applyAllEditings();
              }}
              data-testid='apply_sheet_editing'
            >
              <PiCheckSquareThin
                size={28}
                className={
                  sheetEditorEntity.editingEnabled ? 'fill-accent-green' : ''
                }
              />
            </IconButton>
            <IconButton
              noHover
              onClick={() => {
                sheetEditorEntity.cancelEditing();
              }}
            >
              <PiXSquareThin
                size={28}
                className={
                  sheetEditorEntity.editingEnabled ? 'fill-destructive' : ''
                }
              />
            </IconButton>
          </div>
        )}
      </div>
    </>
  );
});

export default SheetEditor;
